module.exports = __webpack_public_path__ + "img/mkt_purchase_details.9fc1cefe.svg";